module.exports = __webpack_public_path__ + "static/patrick-collison-975a3ecac1feec3f1631997e2d533466.jpg";